export default __webpack_public_path__ + "static/media/hero1.03443987.png";